import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { MuiTelInput } from 'mui-tel-input';
import useLanguagesHooks from '../../Languages/setLanguage-hooks';
import AuthWarning from '../../AuthWarning/authWarning';
import AuthError from '../../AuthError/authError';
import styles from './telInput.module.scss';

interface IProps {
  control: Control<any, any>;
  name: string;
  label?: string;
  error?: any;
  id?: string;
  showTextError?: boolean;
  defaultValue?: string;
  warning?: string | null;
  style?: string;
  labelStyle?: string;
  required?: boolean;
}

const TelInput: React.FC<IProps> = ({
  control,
  name,
  label,
  id,
  error,
  showTextError = true,
  defaultValue = '+374',
  warning = null,
  style,
  labelStyle,
  required = true,
}) => {
  const { t } = useLanguagesHooks();

  return (
    <div className={`${styles.container} ${style}`}>
      {label && (
        <label htmlFor={id} className={`${styles.label} ${labelStyle}`}>
          {label}
          {error && <span className={styles.labelError}>*</span>}
        </label>
      )}

      <Controller
        control={control}
        name={name}
        rules={{
          validate: (value) => value.length > 13,
          required: required ? t('Errors.Required') : false,
        }}
        render={({ field, fieldState }) => (
          <MuiTelInput
            value={field.value || defaultValue}
            onChange={(val) => field.onChange(val)}
            defaultCountry="AM"
            className="custom-tel-input"
            inputMode="tel"
            autoComplete="tel-national"
            InputProps={{
              sx: {
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'transparent',
                  transition: 'border-color 0.3s ease',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'var(--text-dark)',
                },
                '&:focus-within .MuiOutlinedInput-notchedOutline': {
                  border: '1px solid var(--text-dark)',
                },
              },
            }}
            error={fieldState.invalid}
          />
        )}
      />

      {showTextError && <AuthError text={error?.message} />}
      {warning && <AuthWarning text={warning} />}
    </div>
  );
};

export default TelInput;
